import phone from './phone.svg';
import mail from './mail.svg';
import './footer.scss'
import logo from '../header/logo.png'
import clock from './clock.svg'


export default function Footer() {
    return <footer className="footer container">
        <div className="footer__column" data-aos="fade-up">
            <div className="footer__logo">
                <img src={logo} className="logo" alt=""/>
            </div>

            <div className="footer__contact-mobile">
                <div className="footer__contact-title">Our contact:</div>

                <div className="footer__contact-item">
                    <img src={phone} alt=""/> support@freedom7-24.com
                </div>
                <div className="footer__contact-item">
                    <img src={mail} alt=""/> +44 7700 900742
                </div>
            </div>

            <div className="footer__nav" data-aos="fade-up">
                <a href="#about" className="footer__link">About Us</a>
                <a href="#price" className="footer__link">Price</a>
                <a href="#info" className="footer__link">Information</a>
                <a href="#contactBlock" className="footer__link">Support</a>
                <a href="#contactBlock" className="footer__link">Contact Us</a>
            </div>
        </div>

        <div className="footer__column" data-aos="fade-up">
<p>Legal Disclaimer:
    Freedom 24/7 is a technology and financial analytics provider. The platform offers access to market data, educational resources, and evaluation environments designed to simulate CFD-style trading conditions.<br/>
    Freedom 24/7 does not provide investment advice, portfolio management, or brokerage services, and is not registered with IIROC or any provincial securities regulator as a dealer in derivatives or securities. <br/> <br/>
    Corporation Number <a href="https://www.canadacompanyregistry.com/company?utm_source=vsc-capital-inc">9329404</a>  <br/> <br/>
    Registered office address: Suite 1209 300 Bloor Street East Toronto ON M4M 3Y2 Canada</p>

            <div className="footer__contact">

                <div className="footer__contact-title">Our contact:</div>

                <div className="footer__contact-item">
                    <img src={phone} alt=""/> support@freedom7-24.com
                </div>
                <div className="footer__contact-item">
                    <img src={mail} alt=""/> +44 7700 900742
                </div>

            </div>

            <div className="footer__contact">

                <div className="footer__contact-title">Support Hours:</div>

                <div className="footer__contact-item footer__contact-item--start">
                    <img src={clock} alt=""/> <span>Mon–Fri, 8:00 AM–5:00 PM (ET, Ontario)
                                            <span>Closed on weekends and Ontario public holidays</span>
                </span>

                </div>

            </div>
        </div>

        <div className="footer__column">
            © 2026 Freedom 24/7
        </div>
    </footer>
}